import { formatCompletedMarginalia } from '@/learn/completed/_lib/format-marginalia'

// Surface C row 1 — `LESSON N · LEARN COMPLETE · M kanji · K% first-try`. Same
// `text-meta` muted-fg uppercase tracking register as Surfaces A and B; tabular-nums
// holds the lesson + count + rate columns aligned. No vermilion (§7) — this is
// position fact, not progress accent. The count IS the unlock signal.
export function MarginaliaTop({
    lessonNumber,
    kanjiCount,
    firstTryRate,
}: {
    lessonNumber: number
    kanjiCount: number
    firstTryRate: number
}) {
    return (
        <p className="text-meta text-muted-fg uppercase tabular-nums">
            {formatCompletedMarginalia(lessonNumber, kanjiCount, firstTryRate)}
        </p>
    )
}
